<script setup lang="ts">
import type { Column } from '@tanstack/vue-table'
import type { Campaign} from './schema'

import { cn } from 'dashboard/helper/utils'
import { Button } from 'dashboard/components-shadcn/new-york/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'dashboard/components-shadcn/new-york/ui/dropdown-menu'

interface DataTableColumnHeaderProps {
  column: Column<Campaign, any>
  title: string
}

defineProps<DataTableColumnHeaderProps>()
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<template>
  <div v-if="column.getCanSort()" :class="cn('flex items-center space-x-2', $attrs.class ?? '')">
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <Button
          variant="ghost"
          size="sm"
          class="-ml-3 h-8 hover:bg-n-slate-2 dark:hover:bg-n-slate-3 text-n-slate-11 dark:text-n-slate-12 data-[state=open]:bg-n-slate-2 dark:data-[state=open]:bg-n-slate-3"
        >
          <span class="text-n-slate-11 dark:text-n-slate-12 font-medium">{{ title }}</span>
          <span v-if="column.getIsSorted() === 'desc'" class="i-lucide-arrow-down ml-2 h-4 w-4 text-n-slate-9 dark:text-n-slate-11" />
          <span v-else-if="column.getIsSorted() === 'asc'" class="i-lucide-arrow-up ml-2 h-4 w-4 text-n-slate-9 dark:text-n-slate-11" />
          <span v-else class="i-lucide-chevrons-up-down ml-2 h-4 w-4 text-n-slate-8 dark:text-n-slate-10" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="start"
        class="bg-white dark:bg-n-slate-2 border-n-slate-6 dark:border-n-slate-7 shadow-lg rounded-lg overflow-hidden w-36"
      >
        <div class="p-1">
          <DropdownMenuItem
            @click="column.toggleSorting(false)"
            class="flex items-center px-2 py-2 text-sm bg-transparent hover:bg-n-slate-2 dark:hover:bg-n-slate-3 rounded-sm cursor-pointer transition-colors text-n-slate-11 dark:text-n-slate-12"
          >
            <span class="i-lucide-arrow-up mr-2 h-3.5 w-3.5 text-n-slate-9 dark:text-n-slate-10" />
            Crescente
          </DropdownMenuItem>

          <DropdownMenuItem
            @click="column.toggleSorting(true)"
            class="flex items-center px-2 py-2 text-sm bg-transparent hover:bg-n-slate-2 dark:hover:bg-n-slate-3 rounded-sm cursor-pointer transition-colors text-n-slate-11 dark:text-n-slate-12"
          >
            <span class="i-lucide-arrow-down mr-2 h-3.5 w-3.5 text-n-slate-9 dark:text-n-slate-10" />
            Decrescente
          </DropdownMenuItem>

          <div class="my-1 h-px bg-n-slate-4 dark:bg-n-slate-6"></div>

          <DropdownMenuItem
            @click="column.toggleVisibility(false)"
            class="flex items-center px-2 py-2 text-sm bg-transparent hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-700 dark:hover:text-red-400 rounded-sm cursor-pointer transition-colors text-red-600 dark:text-red-400"
          >
            <span class="i-lucide-eye-off mr-2 h-3.5 w-3.5" />
            Ocultar
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>

  <div v-else :class="cn('text-n-slate-11 dark:text-n-slate-12 font-medium', $attrs.class ?? '')">
    {{ title }}
  </div>
</template>